import {ExpertSystemEquipmentType} from '@domain/expert-system'
import {getUrlParam, setOrDeleteStringParam} from '@hconnect/common/utils'
import {useSearchParams} from 'react-router'

export const useExpertSystemEquipmentState = (
  paramName: string,
  defaultValue: ExpertSystemEquipmentType = ExpertSystemEquipmentType.Kiln
) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const equipmentTypeParam = getUrlParam(searchParams, paramName)
  const equipmentType = isEquipmentOption(equipmentTypeParam) ? equipmentTypeParam : defaultValue

  const setEquipmentType = (value: ExpertSystemEquipmentType) => {
    const newParams = new URLSearchParams(searchParams)

    setOrDeleteStringParam(newParams, paramName, value)
    setSearchParams(newParams)
  }

  return {equipmentType, setEquipmentType}
}

const isEquipmentOption = (value: string | undefined): value is ExpertSystemEquipmentType =>
  Object.values(ExpertSystemEquipmentType).includes(value as ExpertSystemEquipmentType)
